import store from "../store";
const color = "#fff";
import helpersJs from "./helpers";

export default {
  getBase64FromUrl(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const urlParts = url.split(".");
        const ext = urlParts[urlParts.length - 1];
        var dataURL = canvas.toDataURL(`image/${ext}`);

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  },
  async receiptHeader() {
    return [
      {
        columns: [
          {
            image: await this.getBase64FromUrl(store.getters.getLogo),

            width: 150,
          },
          [
            {
              text: "Receipt",
              color: "#333333",
              width: "*",
              fontSize: 28,
              bold: true,
              alignment: "right",
              margin: [0, 0, 0, 15],
            },
            {
              stack: [
                {
                  columns: [
                    {
                      text: "Receipt No.",
                      color: "#aaaaab",
                      bold: true,
                      width: "*",
                      fontSize: 12,
                      alignment: "right",
                    },
                    {
                      text: "00001",
                      bold: true,
                      color: "#333333",
                      fontSize: 12,
                      alignment: "right",
                      width: 100,
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: "Date Issued",
                      color: "#aaaaab",
                      bold: true,
                      width: "*",
                      fontSize: 12,
                      alignment: "right",
                    },
                    {
                      text: "June 01, 2016",
                      bold: true,
                      color: "#333333",
                      fontSize: 12,
                      alignment: "right",
                      width: 100,
                    },
                  ],
                },
                {
                  columns: [
                    {
                      text: "Status",
                      color: "#aaaaab",
                      bold: true,
                      fontSize: 12,
                      alignment: "right",
                      width: "*",
                    },
                    {
                      text: "PAID",
                      bold: true,
                      fontSize: 14,
                      alignment: "right",
                      color: "green",
                      width: 100,
                    },
                  ],
                },
              ],
            },
          ],
        ],
      },
    ];
  },
  async companyHeader(textTitle) {
    let companyName = "";
    if (store.getters.getUserCompany.emis == "turning-heads-2025") {
      companyName = "Gence & Associates T/A Turning Heads";
    } else {
      companyName = store.getters.getUserCompany.name;
    }
    return [
      {
        style: [this.getPdfStyles().tableMainHeaderStyle],
        table: {
          widths: ["60%", "40%"],
          body: [
            [
              {
                text: textTitle,
                style: [this.getPdfStyles().header],
                alignment: "left",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: companyName,
                style: [this.getPdfStyles().subHeader],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                image: await this.getBase64FromUrl(store.getters.getLogo),
                border: [false, false, false, false],
                width: 75,
              },
              {
                text: store.getters.getUserCompany.primary_address,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: `VAT No: ${store.getters.getUserCompany.vat_number}`,
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: `${store.getters.getUserCompany.city}, ${store.getters.getUserCompany.postal_code}`,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: `REG No: ${store.getters.getUserCompany.reg_number}`,
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: store.getters.getUserCompany.primary_phone,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: store.getters.getUserCompany.email,
                style: [this.getPdfStyles().email, this.getPdfStyles().italics],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
          ],
        },
      },
      this.myCustomMarginHeaderBottom(),
    ];
  },
  async companyHeaderFrontPage(company, textTitle, logoBase64Url) {
    let companyName = "";
    if (company.emis == "turning-heads-2025") {
      companyName = "Gence & Associates T/A Turning Heads";
    } else {
      companyName = company.name;
    }
    return [
      {
        style: [this.getPdfStyles().tableMainHeaderStyle],
        table: {
          widths: ["60%", "40%"],
          body: [
            [
              {
                text: textTitle,
                style: [this.getPdfStyles().header],
                alignment: "left",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: companyName,
                style: [this.getPdfStyles().subHeader],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                image: logoBase64Url
                  ? logoBase64Url
                  : await this.getBase64FromUrl(store.getters.getLogo),
                border: [false, false, false, false],
                width: 75,
              },
              {
                text: company.primary_address,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: `VAT No: ${company.vat_number}`,
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: `${company.city}, ${company.postal_code}`,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: `REG No: ${company.reg_number}`,
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: company.primary_phone,
                style: [this.getPdfStyles().addressSection],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: " ",
                color,
                fillColor: store.getters.getThemeColor,
              },
              {
                text: company.email,
                style: [this.getPdfStyles().email, this.getPdfStyles().italics],
                alignment: "right",
                border: [false, false, false, false],
                color,
                fillColor: store.getters.getThemeColor,
              },
            ],
          ],
        },
      },
      this.myCustomMarginHeaderBottom(),
    ];
  },
  dateAndPersonalInfo(client, invoiceDate, invoiceNumber, type = "Invoice") {
    return {
      style: [this.getPdfStyles().totalsPane],
      table: {
        widths: ["40%", "*", "*", "40%"],
        body: [
          [
            {
              border: [false, false, false, true],
              fillColor: store.getters.getThemeColor,
              color,
              text: `${client.name}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: store.getters.getThemeColor,
              color,
              text: `${client.position || "N/A"}`,
            },
          ],
          [
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Reference: ${client.client_reference}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `${client.institution || "N/A"}`,
            },
          ],
          [
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `${client.address}. ${client.city}, ${client.postal_code}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, false, false, true],
              fillColor: "#dddddd",
              text: `Date: ${invoiceDate} \n ${type} #: ${invoiceNumber}`,
            },
          ],
        ],
      },
    };
  },
  itemsDetailsTable(selectedInvoice) {
    const items = selectedInvoice.items;

    const itemsTableBody = [this.myCustomMarginTop()];

    if (items.find((item) => item.item_type == "product")) {
      itemsTableBody.push(this.productsHeader());
      items.forEach((item) => {
        if (item.item_type == "product") {
          itemsTableBody.push(this.itemDetails(item));
        }
      });
    }

    if (items.find((item) => item.item_type == "service")) {
      itemsTableBody.push(this.servicesHeader());
      items.forEach((item) => {
        if (item.item_type == "service") {
          itemsTableBody.push(this.itemDetails(item));
        }
      });
    }

    if (items.find((item) => item.item_type == "transportation")) {
      itemsTableBody.push(this.transportsHeader());
      items.forEach((item) => {
        if (item.item_type == "transportation") {
          itemsTableBody.push(this.itemDetails(item));
        }
      });
    }

    return {
      style: [this.getPdfStyles().tableStyle, this.getPdfStyles().totalsPane],
      table: {
        widths: ["52%", "18%", "15%", "15%"],
        body: itemsTableBody,
      },
    };
  },
  tableTotalsPane(selectedInvoice, refNumber, company) {
    return {
      style: [this.getPdfStyles().tableStyle, this.getPdfStyles().totalsPane],
      table: {
        widths: ["40%", "*", 100, "40%"],
        body: [
          this.myCustomMarginTop(),
          [
            {
              border: [true, true, true, true],
              color,
              fillColor: store.getters.getThemeColor,
              text: `Banking Details`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [true, true, true, true],
              color,
              fillColor: store.getters.getThemeColor,
              text: `Computed Summary`,
            },
          ],
          [
            {
              border: [false, true, false, true],
              text: `Bank: ${company.bank}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },

            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Sub Total:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${
                        store.getters.getCurrency
                      } ${helpersJs.formatMoney(selectedInvoice.subTotal)}`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],
          [
            {
              border: [false, true, false, true],
              text: `Account #: ${company.account_number}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Total Vat:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${
                        store.getters.getCurrency
                      }${helpersJs.formatMoney(selectedInvoice.totalTax)}`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],

          [
            {
              border: [false, true, false, true],
              text: `Type: ${company.account_type}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },

            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Discount:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${
                        store.getters.getCurrency
                      } ${helpersJs.formatMoney(selectedInvoice.discount)}`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],
          [
            {
              border: [false, true, false, true],
              text: `Ref#: ${refNumber}`,
            },
            {
              border: [false],
              text: "",
            },
            {
              border: [false],
              text: "",
            },

            {
              border: [false, true, false, true],
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: `Total:`,
                    },
                    {
                      border: [false, false, false, false],
                      text: `${
                        store.getters.getCurrency
                      } ${helpersJs.formatMoney(
                        selectedInvoice.totalInvoiceAmount
                      )}`,
                      alignment: "right",
                    },
                  ],
                ],
              },
            },
          ],
        ],
      },
    };
  },
  productsHeader() {
    return [
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.products}`,
        alignment: "left",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.price}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.quantity}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `Line Total`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
    ];
  },
  servicesHeader() {
    return [
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.services}`,
        alignment: "left",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.fee}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        alignment: "right",
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.duration}`,
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `Line Total`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
    ];
  },
  transportsHeader() {
    return [
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.transportations}`,
        alignment: "left",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.transportationFee} per ${store.getters.getCompanyLabels.distance}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `${store.getters.getCompanyLabels.distance}`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
      {
        border: [true, true, true, true],
        fillColor: store.getters.getThemeColor,
        color,
        text: `Line Total`,
        alignment: "right",
        style: [this.getPdfStyles().addressSection],
      },
    ];
  },
  itemDetails(item) {
    return [
      {
        border: [false, true, false, true],
        text: `${item.name}`,
      },
      {
        border: [false, true, false, true],
        alignment: "right",
        text: `${store.getters.getCurrency}${helpersJs.formatMoney(
          item.price
        )} \n ${item.increments ? "[" + item.increments + "]" : ""}`,
      },
      {
        border: [false, true, false, true],
        alignment: "right",
        text: `${item.quantity ? item.quantity : item.distance}`,
      },
      {
        border: [false, true, false, true],
        alignment: "right",
        text: `${store.getters.getCurrency}${helpersJs.formatMoney(
          item.lineTotal
        )}`,
      },
    ];
  },
  async getContent(
    company,
    description,
    selectedInvoice,
    selectedClient,
    invoiceDate
  ) {
    const content = [];
    const innerContent = [];

    innerContent.push(await this.companyHeader(description));

    if (selectedClient) {
      innerContent.push(
        this.dateAndPersonalInfo(
          selectedClient,
          invoiceDate,
          selectedInvoice.invoiceNumber,
          description
        )
      );
    }

    if (selectedInvoice.items && selectedInvoice.items.length > 0) {
      innerContent.push(this.itemsDetailsTable(selectedInvoice));
    }
    if (
      selectedInvoice.totalServices > 0 ||
      selectedInvoice.totalProducts > 0 ||
      selectedInvoice.totalTransports > 0
    ) {
      innerContent.push(
        this.tableTotalsPane(
          selectedInvoice,
          selectedInvoice.invoiceNumber,
          company
        )
      );
    }
    //if (selectedInvoice && selectedInvoice.description != description) {
    innerContent.push(this.commentLine(selectedInvoice.description));
    //}
    // if (store.getters.getUserCompany.stamp) {
    //   innerContent.push(this.companyStamp());
    // }
    // innerContent.push({
    //   text: `\n ${company.name}`,
    //   alignment: "center",
    // });
    innerContent.push({
      text: `\n created with BitsOffice [076 243 9441]`,
      alignment: "center",
    });
    content.push(innerContent);
    return content;
  },
  async getContentFrontPage(
    company,
    description,
    selectedInvoice,
    selectedClient,
    invoiceDate,
    logoBase64Url
  ) {
    const content = [];
    const innerContent = [];

    innerContent.push(
      await this.companyHeaderFrontPage(company, description, logoBase64Url)
    );

    if (selectedClient) {
      innerContent.push(
        this.dateAndPersonalInfo(
          selectedClient,
          invoiceDate,
          selectedInvoice.invoiceNumber,
          description
        )
      );
    }

    if (selectedInvoice.items && selectedInvoice.items.length > 0) {
      innerContent.push(this.itemsDetailsTable(selectedInvoice));
    }
    if (
      selectedInvoice.totalServices > 0 ||
      selectedInvoice.totalProducts > 0 ||
      selectedInvoice.totalTransports > 0
    ) {
      innerContent.push(
        this.tableTotalsPane(
          selectedInvoice,
          selectedInvoice.invoiceNumber,
          company
        )
      );
    }
    //if (selectedInvoice && selectedInvoice.description != description) {
    innerContent.push(this.commentLine(selectedInvoice.description));
    //}
    // if (store.getters.getUserCompany.stamp) {
    //   innerContent.push(this.companyStamp());
    // }
    // innerContent.push({
    //   text: `\n ${company.name}`,
    //   alignment: "center",
    // });
    innerContent.push({
      text: `\n Created @ https://baronitsolutions.co.za/free-invoices-and-quotes`,
      link: "https://baronitsolutions.co.za/free-invoices-and-quotes",
      color: "blue",
      alignment: "center",
    });

    innerContent.push({
      text: `\n Get BitsOffice [ +27 76 243 9441 | adubyte2@yahoo.com ]`,
      alignment: "center",
    });
    content.push(innerContent);
    return content;
  },
  commentLine(text) {
    return [
      {
        text: `\n ${text}`,
        alignment: "center",
      },
    ];
  },

  myCustomMarginHeaderBottom() {
    return [
      { text: "\n\n", border: [false, false, false, false] },
      { text: "\n\n", border: [false, false, false, false] },
    ];
  },
  myCustomMarginTop() {
    return [
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
      { text: "\n", border: [false, false, false, false] },
    ];
  },
  getPdfStyles() {
    return {
      header: {
        fontSize: 28,
        bold: true,
        margin: [0, 0, 0, 0],
        color,
      },
      subHeader: {
        fontSize: 22,
        bold: true,
        margin: [0, 0, 0, 0],
        color,
      },
      addressSection: {
        fontSize: 14,
        margin: [0, 0, 0, 0],
        color,
        alignment: "left",
      },
      totalsPane: {
        fontSize: 14,
        margin: [0, 0, 0, 0],
        color: "#000",
        alignment: "left",
      },
      fillColumns: {
        margin: [0, 10, 0, 20],
      },
      tableStyle: {
        margin: [0, 0, 0, 0],
      },
      tableMainHeaderStyle: {
        fillColor: store.getters.getThemeColor,
        border: [false, false, false, false],
      },
      email: {
        fontSize: 12,
        color: "#2196F3",
        alignment: "center",
        decoration: "underline",
        margin: [0, 0, 0, 0],
      },
      quote: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
      paragraph: {
        fontSize: 12,
      },
      bold: {
        bold: true,
      },
      italics: {
        italics: true,
      },
      underline: {
        decoration: "underline",
      },
    };
  },
};
